module.exports = __webpack_public_path__ + "img/paytm.6ecf8359.svg";